import { useTransferSectionToGoalMutation } from 'shared/hooks/queries/use-transfer-section-to-goal-mutation';

export const useTransferSectionToGoal = () => {
  const { mutate } = useTransferSectionToGoalMutation();

  return mutate;
};
